export default __webpack_public_path__ + "static/media/6db92e52d2888808.4a45caae792ad057751c8241fc5345a6.svg";